"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;

function log(string) {
  // eslint-disable-next-line no-console
  console.log(string);
}